import { GeneralQuestion } from '../models/question.model';

export function filterMatchingQuestions(
    questions: GeneralQuestion[],
    selections: Record<string, string[]>
): GeneralQuestion[] {
    return questions.filter(question => {
        if (question.custom) return true;
        const requirements = question.requirements as unknown as Record<string, string>;
        return Object.keys(requirements).every(key => selections[key]?.includes(requirements[key]));
    });
}
